import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface InboxIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const InboxIcon: React.FC<InboxIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon inbox')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M508.3 304.9l-61.25-248.7C443.5 41.1 430.7 31.1 416 31.1H96c-14.69 0-27.47 10-31.03 24.25L3.715 304.9C1.248 314.9 0 325.2 0 335.5V416c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64v-80.47C512 325.2 510.8 314.9 508.3 304.9zM108.6 80h294.9L454.7 288H368c-9.094 0-17.41 5.125-21.47 13.28L321.2 352H190.8L165.5 301.3C161.4 293.1 153.1 288 144 288H57.32L108.6 80zM464 416c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16v-80h81.16l25.38 50.72C158.6 394.9 166.9 400 176 400h160c9.094 0 17.41-5.125 21.47-13.28L382.8 336H464V416z" />
      </svg>
    </Tooltip>
  );
};
